import React from 'react';
import { CheckIcon } from 'lucide-react';
export function ValueStackSection() {
  return <section className="py-6 px-4 bg-gray-900 text-white" data-id="element-314">
      <div className="max-w-3xl mx-auto bg-gray-800 rounded-3xl p-5 md:p-8 border-4 border-yellow-400 shadow-2xl" data-id="element-315">
        <h2 className="text-[20px] font-black mb-4 text-center text-[#F9327E] uppercase" data-id="element-316">
          Todo lo que vas a recibir hoy
        </h2>

        <div className="mb-4" data-id="element-317">
          <h3 className="text-2xl font-bold mb-3" data-id="element-318">📦 Acceso inmediato a:</h3>
          <ul className="space-y-2 text-xl pl-4" data-id="element-319">
            <li className="flex items-center font-bold" data-id="element-320">
              <span className="text-yellow-400 mr-3" data-id="element-321">•</span> Ebook principal
              Efemérides Listas
            </li>
            <li className="flex items-center" data-id="element-322">
              <span className="text-yellow-400 mr-3" data-id="element-323">•</span> BONUS 1: Glosas
              Listas
            </li>
            <li className="flex items-center" data-id="element-324">
              <span className="text-yellow-400 mr-3" data-id="element-325">•</span> BONUS 2: Actos
              Resueltos
            </li>
            <li className="flex items-center" data-id="element-326">
              <span className="text-yellow-400 mr-3" data-id="element-327">•</span> BONUS 3: Pack
              Mundial
            </li>
          </ul>
        </div>

        <div className="border-t border-gray-600 pt-4" data-id="element-328">
          <h3 className="text-2xl font-bold mb-3" data-id="element-329">Además vas a tener:</h3>
          <ul className="space-y-2 text-lg" data-id="element-330">
            <li className="flex items-start" data-id="element-331">
              <CheckIcon className="w-6 h-6 text-green-400 mr-3 flex-shrink-0 mt-1" data-id="element-332" />
              <span data-id="element-333">Explicaciones claras de cada efeméride</span>
            </li>
            <li className="flex items-start" data-id="element-334">
              <CheckIcon className="w-6 h-6 text-green-400 mr-3 flex-shrink-0 mt-1" data-id="element-335" />
              <span data-id="element-336">Actividades listas para trabajar</span>
            </li>
            <li className="flex items-start" data-id="element-337">
              <CheckIcon className="w-6 h-6 text-green-400 mr-3 flex-shrink-0 mt-1" data-id="element-338" />
              <span data-id="element-339">Material organizado para todo el año</span>
            </li>
            <li className="flex items-start" data-id="element-340">
              <CheckIcon className="w-6 h-6 text-green-400 mr-3 flex-shrink-0 mt-1" data-id="element-341" />
              <span data-id="element-342">Recursos para actos escolares</span>
            </li>
          </ul>
        </div>
      </div>
    </section>;
}